import { parseMarkdown } from "@/lib/markdown";
import postSorveglianza from "@/content/blog/guida-sorveglianza-sanitaria-pmi.md";
import postVideoterminalisti from "@/content/blog/videoterminalisti-obblighi-2026.md";
import postPrimoSoccorso from "@/content/blog/primo-soccorso-aziendale-gruppo-a-b-c.md";
import postObbligo from "@/content/blog/medico-competente-obbligatorio-quando.md";
import postIdoneita from "@/content/blog/giudizio-idoneita-mansione-come-funziona.md";
import postSopralluogo from "@/content/blog/sopralluogo-medico-competente-cosa-controlla.md";
import postDvr from "@/content/blog/dvr-ruolo-medico-competente.md";
import postNotturno from "@/content/blog/lavoro-notturno-visite-mediche-obbligatorie.md";
import postCarichi from "@/content/blog/movimentazione-manuale-carichi-sorveglianza.md";
import postDrugTest from "@/content/blog/drug-test-lavoro-mansioni-obbligatorie.md";
import postCosto from "@/content/blog/costo-medico-competente-roma.md";
import postCambio from "@/content/blog/come-cambiare-medico-competente.md";
import postCaldo from "@/content/blog/caldo-estivo-lavoro-obblighi-datore.md";
import postStress from "@/content/blog/stress-lavoro-correlato-valutazione-obbligatoria.md";
import postInail from "@/content/blog/malattia-professionale-denuncia-inail.md";
import postInps from "@/content/blog/invalidita-civile-inabilita-certificazioni-inps.md";

const RAW = [
  postSorveglianza,
  postVideoterminalisti,
  postPrimoSoccorso,
  postObbligo,
  postIdoneita,
  postSopralluogo,
  postDvr,
  postNotturno,
  postCarichi,
  postDrugTest,
  postCosto,
  postCambio,
  postCaldo,
  postStress,
  postInail,
  postInps,
];

export const POSTS = RAW.map((mod) => {
  const raw = typeof mod === "string" ? mod : mod.default;
  const { data, body } = parseMarkdown(raw);
  return { ...data, body };
}).sort((a, b) => (a.datePublished < b.datePublished ? 1 : -1));

export function getPost(slug) {
  return POSTS.find((p) => p.slug === slug);
}
